import { Component, Input, OnInit } from '@angular/core';
import { ATPReport } from './atp-report.model';
import { LayoutService } from '@app/layout/layout.service';
import * as g from 'src/app/globals';
import { RecordPageComponent } from '../../record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-available-to-promise',
  templateUrl: './available-to-promise.component.html',
  styleUrls: ['./available-to-promise.component.less'],
})
export class AvailableToPromiseComponent implements OnInit {
  @Input() itemCode: string;
  @Input() warehouse: string = '01';

  atpReport: ATPReport;
  combinedData: CombinedATPStep[] = [];

  warehouses: any[];

  dateFormat = g.companyConfiguration.DateFormat;

  constructor(
    private layoutService: LayoutService,
    private drawerService: NzDrawerService
  ) {}

  ngOnInit(): void {
    this.layoutService.executeQuery(2449, {}).subscribe((result: any[]) => {
      this.warehouses = result;
      this.warehouses.push({ Code: '', Name: 'All' });
      this.fetchAtpReport();
    });
  }

  fetchAtpReport(): void {
    this.layoutService.getAtpReport(this.itemCode, this.warehouse).subscribe(
      (data: ATPReport) => {
        this.atpReport = data;
        this.prepareCombinedData();
      },
      (error) => {
        console.error('Error fetching ATP report:', error);
      }
    );
  }

  prepareCombinedData(): void {
    if (!this.atpReport) {
      return;
    }

    // Same as before
    this.combinedData = this.atpReport.ATPSteps.map((step) => {
      const detail = step.StockDetail;
      return {
        date: step.Date,
        description: step.Description,
        quantityChange: step.QuantityChange,
        cumulativeQuantity: step.CumulativeQuantity,
        documentType: detail?.DocumentType || 'On-Hand Stock',
        docEntry: detail?.DocEntry || '',
        lineNum: detail?.LineNum,
        expectedDate: detail?.ExpectedDate || step.Date,
        documentDate: detail?.DocumentDate || '',
        warehouse: detail?.Warehouse || '',
        cardCode: detail?.CardCode || '',
        cardName: detail?.CardName || '',
        numAtCard: detail?.NumAtCard || '',
        docNum: detail?.DocNum || '',
        isIncoming: detail?.IsIncoming,
      };
    });
  }

  warehouseChanged($event) {
    this.atpReport = {
      ItemCode: '',
      Warehouse: '',
      OnHandStock: 0,
      IncomingStockDetails: [],
      OutgoingStockDetails: [],
      ATPSteps: [],
    };
    this.warehouse = $event;
    this.fetchAtpReport();
  }

  openTargetDocument(step: CombinedATPStep) {
    let moduleId = 0;
    if (step.description.startsWith('SO')) {
      moduleId = 14;
    } else if (step.description.startsWith('PO')) {
      moduleId = 19;
    } else if (step.description.startsWith('TR')) {
      moduleId = 128;
    } else if (step.description.startsWith('IN')) {
      moduleId = 10;
    } else if (step.description.startsWith('WO')) {
      moduleId = 100;
    }

    if (moduleId === 0) {
      return;
    }

    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: 'Edit',
      drawerTitle: step.description,
      inDrawer: true,
      moduleId: moduleId,
      recordId: step.docEntry,
      parentComponent: this,
      recordModel: undefined,
    });
  }
}

// CombinedATPStep interface
interface CombinedATPStep {
  date: Date;
  description: string;
  quantityChange: number;
  cumulativeQuantity: number;
  documentType: string;
  docEntry: string;
  docNum: string;
  lineNum?: number;
  expectedDate: Date;
  warehouse: string;
  cardCode: string;
  cardName: string;
  numAtCard: string;
  isIncoming?: boolean;
}
